function deepEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (typeof a !== 'object' || typeof b !== 'object') return false;

  const aKeys = Object.keys(a).sort();
  const bKeys = Object.keys(b).sort();

  if (aKeys.length !== bKeys.length) return false;

  return aKeys.every((k, i) => {
    if (k !== bKeys[i]) return false;
    if (Array.isArray(a[k])) {
      if (!Array.isArray(b[k])) return false;
      if (a[k].length !== b[k].length) return false;
      return a[k].every((item, idx) => deepEqual(item, b[k][idx]));
    }
    return deepEqual(a[k], b[k]);
  });
}

export const normalizeGroupSnapshot = (source) => {
  if (!source) return null;

  return {
    name: source.name || '',
    description: source.description || '',
    roles: (source.roles || [])
      .map((r) => ({
        roleId: r.roleId,
        grantAdmin: r.grantAdmin,
        updateRole: r.updateRole,
        executeRole: r.executeRole,
      }))
      .sort((a, b) => a.roleId - b.roleId),
    groupAdmins: (source.groupAdmins || [])
      .map((a) => ({ adminId: a.adminId }))
      .sort((a, b) => a.adminId - b.adminId),
    fspAccesses: (source.fspAccesses || [])
      .map((f) => ({ fspId: f.fspId, accessLevel: f.accessLevel }))
      .sort((a, b) => a.fspId - b.fspId),
  };
};

export const matchesExpectedGroup = (
  baseline,
  expectedSnapshot,
  responseSnapshot
) => {
  if (!responseSnapshot) return false;

  const updatedAtAdvanced =
    baseline === null ||
    (responseSnapshot.updatedAt &&
      new Date(responseSnapshot.updatedAt) > new Date(baseline));

  if (!updatedAtAdvanced) return false;

  return deepEqual(expectedSnapshot, normalizeGroupSnapshot(responseSnapshot));
};

export const normalizeRoleSnapshot = (source) => {
  if (!source) return null;

  return {
    name: source.name || '',
    description: source.description || '',
    actions: (source.actions || [])
      .map((a) => ({ actionId: a.actionId, name: a.name }))
      .sort((a, b) => a.actionId - b.actionId),
  };
};

export const matchesExpectedRole = (
  baseline,
  expectedSnapshot,
  responseSnapshot
) => {
  if (!responseSnapshot) return false;

  const updatedAtAdvanced =
    baseline === null ||
    (responseSnapshot.updatedAt &&
      new Date(responseSnapshot.updatedAt) > new Date(baseline));

  if (!updatedAtAdvanced) return false;

  return deepEqual(expectedSnapshot, normalizeRoleSnapshot(responseSnapshot));
};
